import React from 'react';
import { Text } from '@nxt-costco-com/forge-components';
import { ConsentBannerProps } from 'src/components/CookieSettings/ConsentBanner/types';
import { ButtonStack } from 'src/components/CookieSettings/ConsentBanner/ButtonStack';
import { useTranslation } from 'react-i18next';
import {
    popupConsentBannerSx,
    StyledBoxBannerContent,
    StyledBoxPolicyText,
    bannerTitleSx,
} from 'src/components/CookieSettings/ConsentBanner/styles';
import { BannerAnnouncer } from 'src/components/CookieSettings/ConsentBanner/BannerAnnouncer';
import { Popup } from '@nxt-costco-com/forge-components';
export const ConsentBanner: React.FC<ConsentBannerProps> = ({ open, dispatch }: ConsentBannerProps) => {
    const { t } = useTranslation('translation');
    const bannerContent = () => (
        <StyledBoxBannerContent>
            <StyledBoxPolicyText>
                <Text variant="b2">{t('banner.policy')}</Text>
                <Text variant="b2" bold={true}>
                    {t('banner.note')}
                </Text>
            </StyledBoxPolicyText>
            <ButtonStack dispatch={dispatch} />
        </StyledBoxBannerContent>
    );
    return (
        <>
            {open && (
                <Popup
                    announcer={<BannerAnnouncer announcerText={t('title')} />}
                    sx={popupConsentBannerSx}
                    title={t('title')}
                    titleId="costcoConsentBannerTitle"
                    open={true}
                    position="Center"
                    popupName="Costco Consent Banner"
                    popupAriaLabel={t('title')}
                    isNonCloseOrCollapsible={true}
                    isCloseable={false}
                    renderContent={bannerContent}
                    titleSx={bannerTitleSx}
                />
            )}
        </>
    );
};
